<template>
    <div class="has-text-centered pd-20 compare-section">
        <h3 class="compare-section-title text-title">Compare</h3>
        <div class="compare-section-product columns is-multiline is-mobile is-centered">
            <div
                class="column is-6-mobile is-6-tablet is-4-desktop"
                :key="index"
                v-for="(product, index) in products"
            >
                <div class="">
                    <ProductCompareDetail
                    :class="{'active': index < products.length - 1}"
                    :title="product.product_name"
                    :detail="product.product_information"
                    :image="product.product_image[0]"
                    @gotoAddToCart="gotoAddToCart(product)"
                    @openModal="openModal(product)"
                    />
                </div>
            </div>
        </div>
        <div class="has-text-centered md-modal-footer">
          <!-- <b-button
           class="has-text-black md-modal-footer-button-bg"
           @click="gotoorder()"
           >DONE
          </b-button>
          <b-button
            class="has-text-black md-modal-footer-button-white"
            @click="backtoproduct()"
          >
            CANCEL
          </b-button> -->
          </div>
          <b-modal v-model="isCompareModalActive"
            :active="isCompareModalActive"
            :destroy-on-hide="false"
            :can-cancel="false"
        >
            <div class="container md-white-bg">
            <h3 class="has-text-left compare-section-title">
              COMPARE
            </h3>
            <div class="container compare-section">
                <div class="columns ">
                  <div class="column is-5-desktop is-12-mobile selected-img">
                    <img :src="primaryImage">
                  </div>
                  <div class="column is-1-desktop has-text-centered ">
                    <img src="../../assets/img/product/product-compare-1.png"
                    width="90%"
                    class="is-hidden-touch"
                    >
                  </div>
                  <div class="column is-6-desktop is-12-mobile">
                    <div class="columns is-multiline is-mobile auto-scroll">
                      <div
                        v-for="(product, related_index) in compareProductShow"
                        :key="related_index"
                        @click="selectCompare(product,related_index)"
                        class="column is-4-mobile is-6-tablet is-4-desktop compareSection">
                          <img :src="product.product_image[0]" class="md-modal-img">
                        <div class="overlay overlayFade"
                        :class="{ 'activeSelect': activeIndex === related_index}"
                        >
                           <img
                              src="https://ik.imagekit.io/osusf6xvdf/beta/Madam_Ranee_Website_Export-52_PNdNBtYaIcb.png"
                              >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="has-text-centered md-modal-footer">
                  <b-button
                      class="has-text-black is-12-mobile md-modal-footer-button-bg"
                      @click="gotoCompare()"
                      >
                  </b-button>
                  <b-button
                      class="has-text-black is-12-mobile md-modal-footer-button-white"
                      @click="closeModal()"
                    >
                  </b-button>
                </div>
            </div>
            </div>
      </b-modal>
      <OrderFloatIcon />
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { getProducts } from '@/apis/product';
import ProductCompareDetail from '@/components/ProductCompareDetail.vue';
import swal from 'sweetalert';
import OrderFloatIcon from '@/components/OrderFloatIcon.vue';

export default {
  name: 'ProductCompareView',
  components: {
    ProductCompareDetail,
    OrderFloatIcon,
  },
  props: ['ide'],
  data() {
    return {
      productstemp: [],
      product: null,
      productsCart: [],
      isCompareModalActive: false,
      relatedProducts: [],
      compareProductData: [],
      compareProductShow: [],
      primaryImage: null,
      activeIndex: undefined,
      currentProduct: [],
    };
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.products = this.$route.params.compareProduct;
    this.productCart = this.ProductCart;
  },
  computed: mapState({
    ProductCart: state => state.productCart,
  }),
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      // this.product = await getProduct(this.$route.params.id);
      // const { products, total } = await getProducts(this.currPage, this.pageSize);
      // this.products = products;
      const { products } = await getProducts(1, 100);
      this.productstemp = products;
      console.log(this.productstemp);
      // this.findCompareDataShow();
      // this.$store.commit('updateCurrentProductName', this.product.product_name_localized);
      // this.relatedProducts = await getRelatedProducts(this.product.category_id, this.product.id);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    findCompareDataShow(item) {
      const tempIndex = this.productstemp.findIndex(i => i.id === item.id);
      this.compareProductShow = this.productstemp;
      this.compareProductShow.splice(tempIndex, 1);
      // console.log(this.products);
      // this.compareProductShow = this.products.splice(tempIndex, 1);
      // console.log(this.products);
    },
    gotoorder() {
      swal({
        title: 'go to order',
        icon: 'success',
        button: 'Done',
      });
    },
    backtoproduct() {
      swal({
        title: 'back to product',
        icon: 'success',
        button: 'Done',
      });
    },
    gotoAddToCart(x) {
      const tempNum = this.productCart.findIndex(i => i.id === x.id);
      if (tempNum === -1) {
        const tempValue = x;
        tempValue.amount = 1;
        this.productCart.push(tempValue);
      } else {
        this.productCart[tempNum].amount += 1;
      }
      this.$store.commit('updateproductCart',
        this.productCart);
      swal({
        title: 'Add to cart',
        icon: 'success',
        button: 'Done',
      });
    },
    openModal(item) {
      this.isCompareModalActive = !this.isCompareModalActive;
      this.findCompareDataShow(item);
      this.product = item;
      this.primaryImage = this.setPrimaryImage(item.product_image[0]);
    },
    closeModal() {
      this.isCompareModalActive = !this.isCompareModalActive;
    },
    setPrimaryImage(image) {
      return image;
    },
    selectCompare(product, relatedIndex) {
      this.currentProduct = product;
      this.activeIndex = relatedIndex;
    },
    setupCompareProduct(item) {
      return item;
    },
    gotoCompare() {
      this.compareProductData = [];
      this.compareProductData.push(this.product);
      this.compareProductData.push(this.currentProduct);
      this.products = this.setupCompareProduct(this.compareProductData);
      this.$router.push({
        name: 'ProductCompareView',
        params: {
          compareProduct: this.compareProductData
        },
      }).catch(err => err);
      this.isCompareModalActive = !this.isCompareModalActive;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  }
};
</script>
<style lang="scss" scoped>
.activeSelect{
  opacity: 0.8 !important;
}
.modal{
  z-index: 990 !important;
}
.md-modal-img{
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100px;
    height: 100px;
    cursor: pointer;
    border: 1px solid lightgrey;
}
.selected-img{
  border: 1px solid lightgrey;
}
.compareSection{
  position: relative;
}
.compareSection:hover .overlay{
 opacity: 0.7;
}
.auto-scroll{
  max-height:420px;
  overflow: auto;
}
.overlay {
 position: absolute;
 transition: all 0.3s ease;
 opacity: 0;
 background-color: black;
 cursor: pointer;
}
.compareSection:hover .overlay{
 opacity: 0.7;
}
.overlayFade {
    /* height: 50%; */
    width: 69%;
    top: 0;
    left: 0;
    background-color: black;
    margin-top: 8%;
    margin-left: 15.5%;
    cursor: pointer;
    @media screen and (max-width: 768px) {
      width: 85%;
      top: 0;
      left: 0;
      background-color: black;
      margin-top: 10%;
      margin-left: 12%;
    }
}
.md-white-bg{
  background: white;
  background-size: 100%;
  padding: 30px;
  border-radius: 10px;
}
.md-modal-footer{
  display:inline-flex;
   @media screen and (max-width: 900px) {
     display:block;
    }
  &-button-bg{
    padding: 5px 100px 5px 100px;
    margin-right: 20px;
    background: url("https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-19_M-08XVckoFV.png");
    background-position: center;
    margin-top:20px;
     @media screen and (max-width: 900px) {
      margin-right: 0px;
     }
  }
  &-button-white{
    padding: 5px 100px 5px 100px;
    background-position: center;
    background: url("https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-20_jyCMlwDCECdl.png");
    background-position: center;
    margin-top:20px;
  }
}
.compare-section{
  padding: 4%;
    &-title{
        font-size:30px;
        // margin-bottom:3rem;
        margin-bottom: 40px;
        margin-top: 40px;
    }
    &-product{
        margin-bottom:3rem;
    }
}
.pd-20{
    padding: 30px;
}
.text-title{
    font-size: 30px;
}
</style>
